import { Button, Modal } from 'antd';
import React from 'react';
import { CloseIcon } from '../../assets/icons';
import { Link } from 'react-router-dom';

/**
 *
 * @typedef {object} PendingTransferModalProps
 * @property {boolean} open
 * @property {()=>void} onClose
 * @property {()=>void} openTransferFunds
 * @param {PendingTransferModalProps} props
 */
export const PendingTransferModal = (props) => {
  const { onClose, open, openTransferFunds } = props;
  return (
    <Modal open={open} width={524} footer={false} closeIcon={<CloseIcon />} onCancel={onClose} maskClosable={false} centered>
      <div className='text-center mb-48 '>
        <h4 className='success__title mb-16 fw-500'>
          Your <strong>funds</strong> are on way{' '}
        </h4>
        <p className='mb-24 text-taupe w-100'>You have funds currently being transferred. This can take 3 - 5 business days to complete</p>
        <Link className='underline fw-500' to='/account/transactions'>
          View balances and transactions
        </Link>
      </div>

      <Button type='primary' className='ant-btn-primary--alt' block onClick={openTransferFunds}>
        Transfer Additional Funds
      </Button>
    </Modal>
  );
};
